import { Layout } from "./Layout";

export function ServicesListPage(): React.ReactNode {
  return <Layout />;
}
